// Arquivo: sourceProcedureRepository.js
import { request } from './repository';

const url = 'source-procedures/';

const sourceProcedureRepository = {
    showSourceProcedure(id) {
        return request.get(url + id);
    },

    storeSourceProcedure(data) {
        const form = {
            ...data,
            enabled: data.enabled ?? true,
            enable_owner_execution: data.enable_owner_execution ?? false,
            internal_procedure: data.internal_procedure ?? false,
        };
        return request.post(url, form);
    },

    updateSourceProcedure(id, data) {
        return request.put(url + id, data);
    },

    storeQuestionnaire(source_procedure_id, data) {
        return request.post(url + source_procedure_id + '/questionnaires', data);
    },

    removeSourceProcedure(id) {
        return request.delete(url + id);
    },

    getSourceProceduresForMultipleExecution(source_services_id) {
        return request.get('multiple/source-services/' + source_services_id + '/source-procedures');
    },

    getSourceProcedureForMultipleExecution(source_procedure_id) {
        return request.get('multiple/source-services/source-procedure/' + source_procedure_id);
    },

    deleteAllQuestionnaires(source_procedure_id) {
        return request.delete(`${url}${source_procedure_id}/questionnaires`);
    },

    addOrganizationToSourceProcedure(source_procedure_id, payload) {
        return request.put(`source-procedure/${source_procedure_id}/organizations`, payload);
    },
};

export default sourceProcedureRepository;

